import React from 'react'
import { FiChevronRight } from 'react-icons/fi'
import Link from '../../../../components/atoms/link/Link'
import Text from '../../../../components/atoms/text/Text'
import { terms } from '../../../../config'
import routes from '../../../../config/routes'
import { VARIANTS } from '../../../../types/Components.types'
import styles from './FAQ.module.css'

const FAQ = () => {
  return (
    <section className={styles.container}>
      <Text weight="500" size="xl" variant={VARIANTS.white} className={styles.title} align="center">
        FAQ
      </Text>

      <article className={styles.wrapper}>
        <ul className={styles.list}>
          <li className={styles.listItem}>
            <Text className={styles.question} element="span" variant={VARIANTS.white} size="ml" weight="500">
              <FiChevronRight size={18} />
              ¿Cookies? Sí, pero sólo las necesarias
            </Text>

            <Text size="m">
              Seguimos una política de uso mínimo de cookies, nada de fines comerciales, analítica o permisos
              innecesarios. Únicamente te pediremos aquello que sea imprescindible para usar la aplicación.
            </Text>

            <Link path={routes.cookies} className={styles.link}>
              Quiero saber más
              <FiChevronRight size={18} />
            </Link>
          </li>

          <li className={styles.listItem}>
            <Text className={styles.question} element="span" variant={VARIANTS.white} size="ml" weight="500">
              <FiChevronRight size={18} />
              Política de cancelaciones o desistimiento
            </Text>

            <Text size="m">
              Nos ceñimos a la Ordenanza reguladora de uso y funcionamiento del Coworking, en la disposición Décima,
              apartado j):
            </Text>

            <Text size="m">
              Las reservas una vez pagadas no se puede devolver el coste. Si no se usa el servicio por la circunstancia
              que sea, se pierde. Algunos servicios admiten el cambio de fecha, tal y como se ha expuesto en puntos
              anteriores.
            </Text>

            <a className={styles.button} href={terms} rel="noreferrer" target="_blank">
              Consulta la normativa completa
            </a>
          </li>

          <li className={styles.listItem}>
            <Text className={styles.question} element="span" variant={VARIANTS.white} size="ml" weight="500">
              <FiChevronRight size={18} />
              Política de envíos
            </Text>

            <Text size="m">No es aplicable a los servicios que se pueden contratar en la web.</Text>
          </li>

          <li className={styles.listItem}>
            <Text className={styles.question} element="span" variant={VARIANTS.white} size="ml" weight="500">
              <FiChevronRight size={18} />
              ¿Quieres conocer como tratamos tus datos?
            </Text>

            <Text size="m">Nuestra política de tratamiento de datos cumple con la GDPR y es 100% transparente.</Text>

            <Link path={routes.gdpr} className={styles.link}>
              Enséñamelo
              <FiChevronRight size={18} />
            </Link>
          </li>
        </ul>
      </article>
    </section>
  )
}

export default React.memo(FAQ)
